import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {FinderSearchItemData} from '../finder.models';
import {DateHelper} from '../../../helper/date-helper';
import Helper from '../../../helper/helper';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {environment} from '../../../../environments/environment';
import {finderFileName} from '../finder-file-name';

function isValidDate(d) {
  return d instanceof Date && !isNaN(d as any);
}

@Component({
    selector: 'finder-item-content',
    templateUrl: './finder-item-content.component.html',
    styleUrls: ['./finder-item-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FinderItemContentComponent implements OnInit {
  @Input() item: FinderSearchItemData;
  date: string | undefined;
  content: SafeHtml | undefined;
  additionals: { key: string; value: string; }[] = [];
  documentUrl: string;
  fileName: string;

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.documentUrl = environment.apiv4uri + 'finder/document/' + this.item.id + '/';
    this.fileName = finderFileName(this.item.name, this.item.extension);
    if (this.item.content) {
      this.content = this.sanitizer.bypassSecurityTrustHtml(this.item.content);
    }
    if (this.item.archive_date) {
      const easyDate = new Date(this.item.archive_date);
      // compat for v1 (from v0)
      const dateInstance = isValidDate(easyDate) ? easyDate : DateHelper.parseISO8601(this.item.archive_date);
      this.date = DateHelper.format(dateInstance);
    }
    Helper.keys(this.item.additionals, (value, key) => {
      this.additionals.push({key: key, value: value});
    });
    Helper.keys(this.item.multiple_values_additionals, (values, key) => {
      values.forEach(subValue => {
        if (!this.additionals.find(o => o.key === key && o.value === subValue)) {
          this.additionals.push({key: key, value: subValue});
        }
      });
    });
  }

}
